import { FC } from "react";
import { HeartPulseIcon } from "lucide-react-native";

import { VnBox } from "@/components/VnBox";
import { VnIcon } from "@/components/VnIcon";
import { VnScrollView } from "@/components/VnScrollView";
import { OnboardingScreenType } from "@/domain/onboarding";
import { useOnboardingConcernsContent } from "@/hooks/useOnboardingConcernsContent";

import { OnboardingHeader } from "./OnboardingHeader";
import { OnboardingStepFrame } from "./OnboardingStepFrame";
import { PressableOption } from "./PressableOption";

export const OnboardingConcernsStep: FC<OnboardingScreenType> = layout => {
  const { title, description, options, selectedOption, selectOption } =
    useOnboardingConcernsContent();

  return (
    <OnboardingStepFrame {...layout}>
      <VnScrollView
        className="bg-background w-full flex-1"
        contentContainerClassName="items-center px-6 pt-16 pb-6">
        <VnBox className="w-full gap-6 md:max-w-screen-sm">
          <OnboardingHeader
            iconComponent={
              <VnIcon as={HeartPulseIcon} size={48} className="text-sidebar" />
            }
            titleI18nKey={title.i18nKey}
            titleI18nOptions={title.i18nOptions}
            descriptionI18nKey={description.i18nKey}
            descriptionI18nOptions={description.i18nOptions}
          />
          <VnBox className="gap-3">
            {options.map(option => (
              <PressableOption
                key={option.id}
                optionI18nKey={option.text.i18nKey}
                icon={option.icon}
                onPress={() => selectOption(option.id)}
                isSelected={selectedOption === option.id}
              />
            ))}
          </VnBox>
        </VnBox>
      </VnScrollView>
    </OnboardingStepFrame>
  );
};
